export function DraftOrderReanalysisChip() {
  return (
    <span className='rerequisition-chip rerequisition-chip--reanalysis' aria-label='Reanalysis draft'>
      Reanalysis
    </span>
  );
}
